var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396.87 396.88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.375 66.146)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.06,
    cy: 132.29,
    r: 198.44,
    fill: "#28a745",
    strokeLinejoin: "round",
    strokeWidth: 5.8487
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 132.29v-132.29",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.146 132.29-66.146-132.29",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.29 7.7929e-7 -66.146 132.29",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.29 264.58v-264.58",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.44 132.29-132.29 1e-5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.59 66.146 39.688-66.146",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.43 99.219-66.146-99.219",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.28 132.29 66.146-33.073",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.43 165.36-66.146-33.073",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.28 264.58 66.146-99.219",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.59 198.44 39.688 66.146",
    fill: "none",
    stroke: "#000",
    strokeWidth: 15.875
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a0c820564399b84ea80ac64b1ea991d.svg";
export { ForwardRef as ReactComponent };